import React, { useState } from "react";

import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Search from "@material-ui/icons/Search";
import Close from "@material-ui/icons/Close";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core";

import styles from "./styles";
const useStyles = makeStyles(styles);

function SearchField(props) {
  const [searchText, setSearchText] = useState("");
  const classes = useStyles();
  const { fullWidth } = props;

  const handleChange = (e) => {
    const searchText = e.target.value;
    setSearchText(searchText);
    props.onSearch(searchText);
  };

  const handleClear = () => {
    setSearchText("");
    props.onSearch();
  };

  return (
    <div className={classes.container} style={{ width: fullWidth }}>
      <TextField
        size="small"
        variant="outlined"
        value={searchText}
        placeholder={props.placeholder}
        InputProps={
          !searchText
            ? {
                className: classes.input,
                endAdornment: (
                  <InputAdornment position="start">
                    <Search fontSize="small" />
                  </InputAdornment>
                ),
              }
            : {
                className: classes.input,
                endAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      className={classes.clearButton}
                      onClick={handleClear}
                    >
                      <Close fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }
        }
        onChange={handleChange}
      />
    </div>
  );
}

export default SearchField;
